// v1.25.49 — Tiny "cha-ching" chime for admin approvals.
// Zero asset weight: two-oscillator arpeggio via Web Audio API. Respects a
// per-browser mute flag (`localStorage.admin_sound_muted === "1"`) and the
// OS `prefers-reduced-motion` hint (accessibility).
let _ctx = null;
function ctx() {
    if (_ctx) return _ctx;
    try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        _ctx = new AC();
    } catch { _ctx = null; }
    return _ctx;
}

const MUTE_KEY = "admin_sound_muted";
export const isSoundMuted = () => {
    try { return localStorage.getItem(MUTE_KEY) === "1"; } catch { return false; }
};
export const setSoundMuted = (v) => {
    try { localStorage.setItem(MUTE_KEY, v ? "1" : "0"); } catch { /* noop */ }
};

function tone(ac, freq, startAt, duration, gainPeak = 0.18) {
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.type = "triangle";
    osc.frequency.setValueAtTime(freq, startAt);
    gain.gain.setValueAtTime(0.0001, startAt);
    gain.gain.exponentialRampToValueAtTime(gainPeak, startAt + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
    osc.connect(gain).connect(ac.destination);
    osc.start(startAt);
    osc.stop(startAt + duration + 0.02);
}

/** Play the approval chime. Silent if muted or user prefers reduced motion. */
export function playApproveChime() {
    if (isSoundMuted()) return;
    try {
        if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    } catch { /* noop */ }
    const ac = ctx();
    if (!ac) return;
    // Safari auto-suspends the ctx until a user gesture — resume() is idempotent
    if (ac.state === "suspended") { try { ac.resume(); } catch { /* noop */ } }
    const now = ac.currentTime;
    // Cha ("high") – ching ("higher") — a satisfying two-note register jump.
    tone(ac, 880, now,        0.14, 0.20);       // A5
    tone(ac, 1320, now + 0.10, 0.22, 0.22);      // E6 — perfect fifth up
}
